import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';

import { Manifestation, Wemi, Work } from '@skinsoft/entity/'
import { Observable } from 'rxjs';
import { map, pluck, tap, } from 'rxjs/operators';


export class ManifestationOfflineDataFetcher extends OfflineDataFetcher<Manifestation>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    public fetchOneFromId(id: string): Observable<Manifestation> {
        return super.fetchOneFromId(id)
            .pipe(
                map(obj => obj || {}),
                pluck('manifestation')
            )
    }

    public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }

    protected idMatcher(entity: any, id: string) {
        if (entity.manifestation) {
            return entity.manifestation.id === id;
        }
        return false;
    }

}